import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-275c8619"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h4 m-0 mb-4 text-uppercase" }, "Personal Details", -1))
const _hoisted_2 = { class: "row flex-wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h4 m-0 my-4 text-uppercase" }, "Shipping Details", -1))
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = {
  key: 0,
  class: "row flex-wrap"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h6" }, "Address", -1))
const _hoisted_7 = { class: "row flex-wrap align-items-center gy-2 col-12" }
const _hoisted_8 = { class: "col-auto" }

import { ElMessage } from "element-plus";
import type { FormInstance, FormRules } from "element-plus";
import { onBeforeMount, reactive, ref, Ref } from "vue";
import { ValidateFieldsError } from "async-validator";
// import { useAuthStore } from "@/stores/auth";
import { useUserStore } from "@/stores/user";
// import { ApiAccountLoginPostRequest } from "@/api-client";
import { useRoute, useRouter } from "vue-router";
import countries from "@/assets/json/countries.json";
import { formatDate } from "@/utilities";
import { handleInvalidForm } from "@/utilities/api";
import { useMiscStore } from "@/stores/misc";
import Spinner from "@/components/spinner/Spinner.vue";

type UserProfile = {
  id: string;
  default_billing: string;
  default_shipping: string;
  firstname: string;
  lastname: string;
  email: string;
  addresses: CustomerAddress[];
};

type CustomerAddress = {
  id: string;
  customer_id: string;
  region: {
    region: string | null;
    region_code?: string | null;
    region_id?: string | null;
  };
  region_id: number;
  country_id: string;
  street: [string | null, string | null];
  telephone: string;
  postcode: string;
  city: string;
  firstname: string;
  lastname: string;
  vat_id: string;
  company: string;
  default_billing: boolean;
};

// const authStore = useAuthStore();

export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileForm',
  setup(__props) {

const userStore = useUserStore();
const countriesDdl = countries;
const profileFormRef = ref<FormInstance>();
let formData: Ref<UserProfile> = ref({
  id: "",
  default_billing: "0",
  default_shipping: "0",
  firstname: "",
  lastname: "",
  email: "",
  addresses: [],
});
let defaultShipping: Ref<number | null> = ref(null);
const route = useRoute();
const router = useRouter();

const rules = reactive<FormRules<UserProfile>>({
  firstname: [
    {
      required: true,
      message: "Please enter a valid first name",
      trigger: "change",
    },
  ],
  lastname: [
    {
      required: true,
      message: "Please enter a valid last name",
      trigger: "change",
    },
  ],
  email: [
    {
      required: true,
      type: "email",
      message: "Please enter a valid email address",
      trigger: "change",
    },
  ],
});

const miscStore = useMiscStore();
onBeforeMount(async () => {
  miscStore.isLoading = true;
  const profileResult = (await userStore.getProfile());
  formData.value = profileResult.result as UserProfile;
  miscStore.isLoading = false;
  getDefaultAddress();
});

const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  await formEl.validate(async (valid, fields) => {
    if (valid) {
      miscStore.isLoading = true;
      await userStore.updateProfile(formData.value).then(() => {
        ElMessage.success({ message: `Update successful`, showClose: true, grouping: true, duration: 3000 });
        miscStore.isLoading = false;
      })
      .catch(() => {
        miscStore.isLoading = false;
      })
    } else {
      handleInvalidForm(fields as ValidateFieldsError)
    }
  });
};

function getDefaultAddress () {
  defaultShipping.value = Number(formData.value.default_shipping || 0);
  if (!formData.value.addresses.length) {
    formData.value.addresses.push({
      id: "0",
      customer_id: "1",
      region: {
        region: "South Africa",
      },
      region_id: 0,
      country_id: "ZA",
      street: [null, null],
      telephone: "",
      postcode: "",
      city: "",
      firstname: "",
      lastname: "",
      vat_id: "",
      company: "",
      default_billing: true,
    });

    defaultShipping.value = 0;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref_key: "profileFormRef",
    ref: profileFormRef,
    class: "profile-form position-relative col-12",
    model: _unref(formData),
    rules: rules,
    size: "large",
    "label-position": "top",
    "require-asterisk-position": "right"
  }, {
    default: _withCtx(() => [
      _createVNode(Spinner, {
        isAbsolute: true,
        visible: _unref(miscStore).isLoading
      }, null, 8, ["visible"]),
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_form_item, {
          class: "col-12 col-md-6 mb-3 mb-md-4",
          label: "First name",
          prop: "firstname"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              name: "firstname",
              modelValue: _unref(formData).firstname,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).firstname) = $event)),
              placeholder: "Enter your first name (*)"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          class: "col-12 col-md-6 mb-3 mb-md-4",
          label: "Last name",
          prop: "lastname"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              name: "lastname",
              modelValue: _unref(formData).lastname,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formData).lastname) = $event)),
              placeholder: "Enter your last name (*)"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          class: "col-12 col-md-6 mb-3 mb-md-4",
          label: "Email",
          prop: "email"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              name: "email",
              type: "email",
              modelValue: _unref(formData).email,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formData).email) = $event)),
              placeholder: "Enter your email (*)"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_unref(defaultShipping))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_el_form_item, {
                class: "col-12 col-md-6 mb-3 mb-md-4",
                label: "House/ Apartment number",
                prop: `addresses[${_unref(defaultShipping)}].street[1]`
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    name: `addresses[${_unref(defaultShipping)}].street[1]`,
                    modelValue: _unref(formData).addresses[_unref(defaultShipping)].street[1],
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formData).addresses[_unref(defaultShipping)].street[1]) = $event)),
                    placeholder: "Enter your house/ apartment number (*)"
                  }, null, 8, ["name", "modelValue"])
                ]),
                _: 1
              }, 8, ["prop"]),
              _createVNode(_component_el_form_item, {
                class: "col-12 col-md-6 mb-4 mb-md-5",
                label: "Street name",
                prop: `addresses[${_unref(defaultShipping)}].street[0]`
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    name: `addresses[${_unref(defaultShipping)}].street[0]`,
                    modelValue: _unref(formData).addresses[_unref(defaultShipping)].street[0],
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formData).addresses[_unref(defaultShipping)].street[0]) = $event)),
                    placeholder: "Enter your street name (*)"
                  }, null, 8, ["name", "modelValue"])
                ]),
                _: 1
              }, 8, ["prop"]),
              _createVNode(_component_el_form_item, {
                class: "col-12 col-md-6 mb-4 mb-md-5",
                label: "City",
                prop: `addresses[${_unref(defaultShipping)}].city`
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    name: `addresses[${_unref(defaultShipping)}].city`,
                    modelValue: _unref(formData).addresses[_unref(defaultShipping)].city,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(formData).addresses[_unref(defaultShipping)].city) = $event)),
                    placeholder: "Enter your city (*)"
                  }, null, 8, ["name", "modelValue"])
                ]),
                _: 1
              }, 8, ["prop"]),
              _createVNode(_component_el_form_item, {
                class: "col-12 col-md-6 mb-4 mb-md-5",
                label: "Province",
                prop: `addresses[${_unref(defaultShipping)}].region.region`
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    name: `addresses[${_unref(defaultShipping)}].region.region`,
                    modelValue: _unref(formData).addresses[_unref(defaultShipping)].region.region,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(formData).addresses[_unref(defaultShipping)].region.region) = $event)),
                    placeholder: "Enter your region (*)"
                  }, null, 8, ["name", "modelValue"])
                ]),
                _: 1
              }, 8, ["prop"]),
              _createVNode(_component_el_form_item, {
                class: "col-12 col-md-6 mb-4 mb-md-5",
                label: "Zip-code",
                prop: `addresses[${_unref(defaultShipping)}].postcode`
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    name: `addresses[${_unref(defaultShipping)}].postcode`,
                    modelValue: _unref(formData).addresses[_unref(defaultShipping)].postcode,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(formData).addresses[_unref(defaultShipping)].postcode) = $event)),
                    placeholder: "Enter your zip-code (*)"
                  }, null, 8, ["name", "modelValue"])
                ]),
                _: 1
              }, 8, ["prop"]),
              _createVNode(_component_el_form_item, {
                class: "col-12 col-md-6 mb-4 mb-md-5",
                label: "Country",
                prop: `addresses[${_unref(defaultShipping)}].country_id`
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    name: `addresses[${_unref(defaultShipping)}].country_id`,
                    modelValue: _unref(formData).addresses[_unref(defaultShipping)].country_id,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(formData).addresses[_unref(defaultShipping)].country_id) = $event)),
                    placeholder: "Select your country (*)"
                  }, null, 8, ["name", "modelValue"])
                ]),
                _: 1
              }, 8, ["prop"]),
              _createVNode(_component_el_form_item, {
                class: "col-12 col-md-6 mb-4 mb-md-5",
                label: "Phone number",
                prop: `addresses[${_unref(defaultShipping)}].telephone`
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    name: `addresses[${_unref(defaultShipping)}].telephone`,
                    modelValue: _unref(formData).addresses[_unref(defaultShipping)].telephone,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(formData).addresses[_unref(defaultShipping)].telephone) = $event)),
                    placeholder: "Enter your phone number (*)"
                  }, null, 8, ["name", "modelValue"])
                ]),
                _: 1
              }, 8, ["prop"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-dark",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (submitForm(profileFormRef.value)))
          }, " Save ")
        ])
      ])
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}
}

})